import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { apiGetPage, apiEditInfo } from '../../request/api'
import { Modal, message } from 'antd';
import NotHaveInfo from '../nothaveinfo';


interface ChooseManagementProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}

interface invoiceInfo {
    id: string;
    invoicePhone: string;
    invoiceBank: string;
    invoiceAddress: string;
    invoiceIdentification: string;
    invoiceHeader: string;
    bankCardNumber: string;
}

const formatDate = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0'); // 添加秒数
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

const ChooseManagement: React.FC<ChooseManagementProps> = ({ handleViewChange, data }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [invoiceList, setInvoiceList] = useState<invoiceInfo[]>([]);
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        apiGetPage({
            tid: '809BB53916314B70AE9F79EA842C5D42',
            page: 1,
            size: 1000,
            sort: 'status'
        }).then(res => {
            setInvoiceList(res.data.data.rows)
            console.log(res.data.data.rows);
        }).catch(err => {
            console.log(err)
        });
    }, []);


    const goBack = () => {
        handleViewChange('management')
    }
    const handleItemClick = (index: number) => {
        setSelectedIndex(index);
    };
    const goNew = () => {
        handleViewChange('management')
    }
    const chooseOk = () => {
        if (selectedIndex == -1) {
            messageApi.open({
                type: 'error',
                content: '请选择发票',
            })
        } else {
            const currentDate = formatDate(new Date());
            console.log(currentDate)
            // apiEditInfo({
            //     tid: '4DCDCEA81A6C40618E5C121024774B64',
            //     did: data,
            //     invoiceNumber: invoiceList[selectedIndex].id,
            //     invoicePhone: invoiceList[selectedIndex].invoicePhone,
            //     invoiceBank: invoiceList[selectedIndex].invoiceBank,
            //     invoiceAddress: invoiceList[selectedIndex].invoiceAddress,
            //     invoiceIdentification: invoiceList[selectedIndex].invoiceIdentification,
            //     invoiceHeader: invoiceList[selectedIndex].invoiceHeader,
            //     bankCardNumber: invoiceList[selectedIndex].bankCardNumber,
            //     invoiceStatus: "1",
            //     applyInvoice_at: currentDate,
            // }).then(res => {
            //     messageApi.open({
            //         type: 'success',
            //         content: '申请开票成功，请静待处理',
            //     })
            //     setTimeout(() => {
            //         handleViewChange('management')
            //     }, 2000); 
            // })
        }
    }
    return (
        <div className="ChooseManagement">
            {contextHolder}
            <div className='detail-back' style={{ color: themeColor }}>
                <ArrowLeftOutlined onClick={goBack} />
                <div className='detail-back-right' onClick={goBack}> 返回 </div>
                <div className='detail-back-right' onClick={goNew}> 新增发票 </div>
            </div>
            <div className='management-chooselist'>
                {invoiceList.map((item, index) => (
                    <div
                        key={index}
                        style={{ border: index === selectedIndex ? `1px solid ${themeColor}` : '1px solid #e5e5ee' }}
                        className='management-chooseitem'
                        onClick={() => handleItemClick(index)}
                    >
                        <div className='kangbuning' style={{
                            color: index === selectedIndex ? themeColor : 'inherit',
                            borderBottom: index === selectedIndex ? `1px solid ${themeColor}` : '1px solid #e5e5ee'
                        }}>
                            {item.invoiceHeader}
                        </div>
                        <p style={{ marginTop: '14px' }}>纳税人识别号：{item.invoiceIdentification}</p>
                        <p>企业地址：{item.invoiceAddress}</p>
                        <p>联系电话：{item.invoicePhone}</p>
                        <p>开户行：{item.invoiceBank}</p>
                        <p style={{ paddingBottom: '14px' }}>企业账号：{item.bankCardNumber}</p>
                    </div>
                ))}
                {invoiceList.length == 0 &&
                    <NotHaveInfo />
                }
            </div>
            <button className='pay-button' onClick={chooseOk} style={{ marginTop: '170px' }}>确认</button>

        </div>
    );
};

export default ChooseManagement;